import routes from "@/routers/routes";
import PageHeader from "@/app/shared/page-header";
import ExportButton from "@/app/shared/export-button";
import { Client } from "@/types";
import AddClientModal from "@/app/shared/clients/add-client-modal";
import { title } from "process";

interface HeaderProps {
    title: string;
    clients?: Client[];
}

export default function ClientPageHeader({
    title,
    clients,
}: HeaderProps) {

    const pageHeader = {
        title: title,
        breadcrumb: [
            {
                href: "/",
                name: "Home",
            },
            {
                href: routes.clients.list,
                name: "Clients",
            },
        ],
    };
    return (
        <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb}>
            <div className="mt-4 flex flex-col items-center gap-3 @sm:flex-row @lg:mt-0">
                <ExportButton
                    data={clients ?? []}
                    fileName="order_data"
                    header="ID,Tracking ID,Date,Sender,Receiver,Origin,Destination,Payment Method,Status"
                />
            </div>
        </PageHeader>
    );
}
